import { useEffect, useState } from "react";
import styled from "@emotion/styled/macro";
import { withProps } from "recompose";
import CompanyLogo from "../../../assets/images/bgwf-fcgb.png";
import FooterMenu from "../../ui/FooterMenu";
import { useTranslation } from "react-i18next";
import { filterMenuBasedOnCms } from "../../../helpers/helpers";

import LanguageBox from "../../ui/LanguageBox";
import { ContentLayout } from "../../ui/ContentLayout";
import { Link } from "react-router-dom";
import { menuItems } from "../../ui/Menu/Menu";
import { secondaryMenuItems } from "../../ui/SecondaryMenu/SecondaryMenu";

const Container = styled.footer`
  background-color: ${({ theme }) => theme.colors.footer};
  height: 56.25em;
`;
const Wrapper = styled(ContentLayout)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 1em 2em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 0;
    justify-content: space-between;
    flex-direction: row;
    align-items: baseline;
  }
`;
const LogoWrapper = styled.div`
  order: 3;
  padding: 3em 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    order: initial;
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`;
const Logo = withProps({ src: CompanyLogo })(styled.img`
  margin-top: 7px;
  margin-left: -17px;
`);

const Label = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.white};
`;
const Rights = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.opal};
  order: 4;
  margin-top: 1em;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    order: initial;
    margin-top: 0;
  }
`;

const MenuWrapper = styled.div`
  font-weight: bold;
  margin-bottom: 1em;
  ul {
    display: flex;
    list-style-type: none;
    flex-direction: column;
  }
  li {
    font-family: ${({ theme }) => theme.fonts.heading};
    padding: 0.5em 0;
    color: ${({ theme }) => theme.colors.white};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    li {
      padding: ${({ theme }) => theme.layout.header.menu.spacing} 0;
      font-size: ${({ theme }) => theme.fontSizes.md};
    }
  }
`;
const SecondaryMenuWrapper = styled.div`
  margin: 2em 0;
  padding: 1em 0;
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.aero};
  border-top: 1px solid ${({ theme }) => theme.colors.aero};

  ul {
    display: flex;
    flex-wrap: wrap;
    list-style-type: none;
    flex-direction: column;
    height: ${({ rowCount }) => 2.5 * rowCount + 1}em;
  }
  li {
    display: flex;
    flex: 0 0 2.5em;
    width: 50%;
    align-items: center;
  }
  .col2 {
    display: flex;
    justify-content: flex-end;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border: none;
    ul {
      flex-wrap: nowrap;
      height: initial;
    }
    li {
      width: 100%;
      padding: ${({ theme }) => theme.layout.header.menu.spacing} 0;
    }
    .col2 {
      display: flex;
      justify-content: flex-start;
    }
  }
`;

const FooterMenuWrapper = styled.div`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.opal};
  order: 4;

  ul {
    display: flex;
    list-style-type: none;
    flex-direction: column;
    order: 2;
  }
  li {
    padding: 0.5em 0;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    order: initial;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    ul {
      display: flex;
      list-style-type: none;
      flex-direction: row;
    }
    li {
      padding: 1em 0.5em;
    }
  }
`;

const LanguageWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-self: baseline;
    display: block;
  }
  display: none;
`;

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [filteredMenu, setFilteredMenu] = useState();

  useEffect(() => {
    const filterMenu = async () => {
      const result = await filterMenuBasedOnCms(menuItems, language);
      setFilteredMenu(result);
    };
    filterMenu(); // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Wrapper>
        <LogoWrapper>
          <Label>{t("common.projectby")}</Label>
          <Logo />
        </LogoWrapper>

        <MenuWrapper>
          <ul>
            {filteredMenu?.map((item) => (
              <li>
                <Link to={item.link}>{t(item.label)}</Link>
              </li>
            ))}
          </ul>
        </MenuWrapper>

        <SecondaryMenuWrapper rowCount={Math.ceil(secondaryMenuItems.length / 2)}>
          <ul>
            {secondaryMenuItems.map((item, index) => (
              <li className={index >= filteredMenu?.length / 2 ? "col2" : undefined}>
                <Link to={item.link}>{t(item.label)}</Link>
              </li>
            ))}
          </ul>
        </SecondaryMenuWrapper>
        <LanguageWrapper>
          <LanguageBox colorTheme={"white"} margin={"6.5em 0 0 0"} />
        </LanguageWrapper>
        <FooterMenuWrapper>
          <FooterMenu />
          <Rights>{t("header.footerMenu.rights")}</Rights>
        </FooterMenuWrapper>
      </Wrapper>
    </Container>
  );
};

export default Footer;
